<template>
  <div class="flex">
    <div class="w-full">
      <nav id="navbar" class="flex bg-secondary-500 inset-x-0 items-center py-2 ">
        <div class="w-full relative mx-10">
          <div class="flex items-center justify-between lg:mr-4 py-2">
            <div class="flex items-center lg:mr-4 py-2">
              <div class="flex items-center text-white cursor-pointer text-lg" @click="toggleSidenav()">
                <d-icon icon="bars" class="mr-2" />
                <span>Menu</span>
              </div>
            </div>
            <div class="w-full flex-grow sm:flex items-center sm:w-auto ml-8 sm:items-center navbar-links">
              <div class="text-md sm:flex-grow">
                <div class="flex justify-end items-center">
                  <a href="/home/whatsnew">
                    <d-tooltip label="See what's new." position="bottom">
                      <div class="mr-6 px-2">
                        <d-icon v-if="hasRole('System Administrator')" icon="info-circle" class="text-white cursor-pointer pt-2" size="lg" />
                      </div>
                    </d-tooltip>
                  </a>

                  <d-badge :content="unreadNotifications" :value="unreadNotifications" class="mr-6">
                    <d-icon icon="bell" class="text-white cursor-pointer pt-2" size="lg" @click="goToMyNotifications" />
                  </d-badge>

                  <d-dropdown aria-role="list">
                    <div slot="activator" class="flex items-center py-1">
                      <d-avatar :text="profile.fullName" :img-src="profile.profilePictureUrl" class="mr-3 ml-2 my-0" size="30px" />
                      <span class="text-white hidden md:block">{{ profile.fullName }}</span>
                    </div>
                    <a href="/profile" class="dropdown-item no-underline" aria-role="listitem">Profile</a>
                    <a href="/manageaccount/changepassword" class="dropdown-item no-underline" aria-role="listitem">Change Password</a>
                    <a href="javascript:void(0)" class="dropdown-item no-underline" aria-role="listitem" @click="openFeedbackModal()">Submit Feedback</a>
                    <a v-if="hasRole('System Administrator')" target="_blank" href="/account/supportlogin" class="dropdown-item no-underline" aria-role="listitem">Support</a>
                    <a href="/account/logout" class="dropdown-item no-underline" aria-role="listitem">Logout</a>
                  </d-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import FeedbackModal from './SubmitFeedbackModal.vue';

  export default {
    parent: true,
    props: {
      unreadNotifications: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        notifications: [],
      };
    },

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole']),
    },

    methods: {
      ...mapActions('sidenav', ['toggleSidenav']),

      goToMyNotifications() {
        window.location.href = '/home/mynotifications';
      },

      openFeedbackModal() {
        this.$modal.open({
          parent: this,
          component: FeedbackModal,
          hasModalCard: true,
          width: 600,
        });
      },
    },
  };
</script>